<template>
  <header class="guard-header">
    <div class="guard-header__brand">
      <span class="guard-header__fuse">fuse</span><span class="guard-header__access">access</span><span class="guard-header__dot">·</span>
    </div>
    <div class="guard-header__right">
      <div class="guard-header__status-pill">
        <span class="guard-header__status-dot"></span>Sistema activo
      </div>
      <div class="guard-header__clock">
        <span class="guard-header__clock-date">{{ date }}</span>
        <span class="guard-header__clock-time">{{ time }}</span>
      </div>
    </div>
  </header>
</template>

<script>
const MONTHS = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

export default {
  name: "Header",
  data() {
    return {
      date: undefined,
      time: undefined,
      intervalId: undefined,
    };
  },
  mounted() {
    this.updateDateTime();
    this.intervalId = setInterval(() => {
      this.updateDateTime();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      const h = now.getHours();
      const m = now.getMinutes();
      const s = now.getSeconds();
      const pad = (x) => String(x).padStart(2, "0");
      this.date = `${now.getDate()} de ${MONTHS[now.getMonth()]} de ${now.getFullYear()}`;
      this.time = `${pad(h % 12 || 12)}:${pad(m)}:${pad(s)} ${h >= 12 ? "PM" : "AM"}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../styles';

.guard-header {
  height: 4rem;
  flex-shrink: 0;
  background: $guard-navy-900 !important;
  @include guard-flex-center-between;
  padding: 0 1.6rem;
  box-shadow: $guard-shadow-topbar;

  &__brand {
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 1.15rem;
    letter-spacing: -0.01em;
  }
  &__fuse { color: #fff; font-weight: 700; }
  &__access { color: $guard-cyan-500; font-weight: 400; }
  &__dot {
    color: $guard-cyan-500;
    font-size: 1.4rem;
    line-height: 0;
    margin-left: 0.15rem;
  }
  &__right {
    display: flex;
    align-items: center;
    gap: 1.1rem;
  }
  &__status-pill { @include guard-status-pill; }
  &__status-dot { @include guard-dot($guard-accent-green, 0.42rem, 2.2s); }
  &__clock {
    font-size: 0.9rem;
    font-weight: 500;
    color: $guard-clock-time;
    min-width: 9.5rem;
    text-align: right;
    letter-spacing: 0.02em;
    line-height: 1.25;
  }
  &__clock-date {
    display: block;
    font-size: 0.68rem;
    color: $guard-clock-date;
    font-weight: 400;
    text-transform: capitalize;
  }
  &__clock-time { display: block; }
}

@media (max-width: $guard-bp-sm) {
  .guard-header {
    padding: 0 0.75rem;
    gap: 0.4rem;

    &__right { gap: 0.4rem; }
    &__status-pill { display: none; }
    &__clock { min-width: 0; font-size: 0.68rem; }
    &__clock-date { font-size: 0.56rem; }
  }
}
</style>